<div class="dropdown-container" [class.disabled]="control.disabled">
  <label *ngIf="label">{{ label }}</label>

  <div class="dropdown-wrapper" [class.open]="dropdownOpen" [class.error]="control.invalid && control.touched"
    (click)="toggleDropdown()">
    
    <div class="selected-items">
      <ng-container *ngIf="multiSelect && selectedValues.length > 0; else singleSelection">
        <div class="selected-chip" *ngFor="let selected of selectedValues">
          {{ getOptionLabel(selected) }}
          <button type="button" class="remove-chip" (click)="removeSelectedItem(selected, $event)">✕</button>
        </div>
      </ng-container>
    
      <ng-template #singleSelection>
        <div class="single-selection-container">
          <span class="selected-value">
            {{ getSelectedText() || 'Selecciona una opción' }}
          </span>
  
        </div>
      </ng-template>
    </div>
    
  
    <!-- Icono de abrir/cerrar -->
    <span class="dropdown-icon">▼</span>

    <!-- Dropdown desplegado -->
    <div *ngIf="dropdownOpen" class="dropdown-content" [class.open-upwards]="openUpwards"
      (click)="$event.stopPropagation()">
      <ul class="dropdown-list">
        <!-- Optional Search Bar -->
        <input *ngIf="enableSearch" type="text" [(ngModel)]="searchQuery" (ngModelChange)="filterOptions()"
          placeholder="Buscar..." class="search-bar" />

        <li *ngFor="let option of filteredOptions" (click)="selectOption(option.value)"
          [class.selected]="isSelected(option.value)" class="dropdown-item">
          <span>{{ option.label }}</span>
          <img *ngIf="isSelected(option.value)" class="checkmark" src="assets/initial-form/check.svg" alt="Check" />
        </li>
      </ul>
    </div>
  </div>

  <p class="error-message" [class.active]="control.invalid && control.touched">
    {{ getErrorMessage() }}
  </p>
</div>